<template>
  <section class="p-3">
    <loading-flux :value="loading"></loading-flux>
    <section class="d-flex flex-column flex-sm-row justify-content-between">
      <h2 class="ml-1 my-2">
        {{ title }}
        {{
          $route.query.sap_project ? `| COD: ${$route.query.sap_project}` : ""
        }}
      </h2>
      <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
    </section>
    <v-row align-content="center" align-md="center" class="mt-1">
      <v-col cols="12" md="4" sm="12" v-if="!$route.query.sap_project">
        <label for="proyect"> Filtrar por Estatus </label>
        <v-autocomplete
          v-model="filters.status_filter"
          clearable
          :items="approvedRequestsStatus"
          @input="getApprovedRequestsData(1)"
          hide-details
          item-text="name"
          item-value="id"
          label="Todos"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4" sm="12" v-if="!$route.query.sap_project">
        <label for="proyect"> Filtrar por Proyecto </label>
        <v-autocomplete
          v-model="filters.project_code"
          clearable
          :items="
            projects.items
              ? projects.items.filter((item) => item.warehouse)
              : []
          "
          @input="changeProjectFilter()"
          @update:search-input="getProjectsData"
          @click:clear="getProjectsData"
          class=""
          hide-details
          item-text="name_code"
          no-data-text="Sin proyectos"
          :loading="loadingProjects"
          label="Todos"
        ></v-autocomplete>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="12"
        class="pt-0 pb-0"
        v-if="filters.project_code && currentFilterProjectIsResidential"
      >
        <section>
          <label for="proyect">
            Filtrar por Orden de Venta
          </label>
          <v-autocomplete
            label="Orden de venta"
            v-model="filters.sale_order"
            @update:search-input="getSaleOrdersData"
            @change="getApprovedRequestsData(1)"
            :items="saleOrdersFromProject"
            clearable
            item-value="name"
            item-text="name"
            hide-details=""
          >
          </v-autocomplete>
        </section>
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <div v-if="!$route.query.sap_project">
          <label for="proyect"> Filtrar por CECO </label>
          <v-autocomplete
            v-model="filters.cost_center"
            clearable
            :items="cecos.items ? cecos.items : []"
            @input="getApprovedRequestsData(1)"
            @update:search-input="getCecosData"
            @click:clear="getCecosData"
            class=""
            hide-details
            item-text="name_code"
            no-data-text="Sin CECOS"
            :loading="loadingCecos"
            label="Todos"
          ></v-autocomplete>
        </div>
      </v-col>
      <!-- <v-col cols="12" md="4" sm="12">
        <label for="proyect"> Filtro de Búsqueda </label>
        <v-text-field
          v-model="filters.filter"
          clearable
          placeholder="Buscar"
          hide-details
        ></v-text-field>
      </v-col> -->
      <v-col cols="12" md="4" sm="12"> </v-col>
      <v-col cols="12" md="4" sm="12">
        <p class="my-0 text-right mt-3">
          Número de Solicitudes Total:
          {{ approveRequests.total_items }}
        </p>
      </v-col>
    </v-row>

    <v-tabs v-model="tab" fixed-tabs class="mt-4">
      <v-tab key="0" id="approvalList"> Por Aprobar </v-tab>
      <v-tab key="1" id="requesterList"> Mis Solicitudes </v-tab>
    </v-tabs>

    <v-data-table
      class="elevation-3 px-5 py-3 mt-5"
      :headers="wrappedHeaders"
      :items="approveRequests.items"
      :item-class="rowColor"
      :items-per-page="20"
      :page.sync="filters.page"
      :loading="loadingApproveRequests"
      loading-text="Cargando solicitudes"
      item-key="id"
      hide-default-footer
      no-data-text="Sin Solicitudes"
      @page-count="pageCount = $event"
      @update:sort-by="updateSortBy"
      @update:sort-desc="updateSortDesc"
      :key="keyTable"
    >
      <template v-slot:item.unique_supplier="{ item }">
        <span
          class="mt-2"
          :class="{
            'text-primary font-weight-bold': getRequestIsUniqueSupplier(item),
          }"
          style="font-size: 11px"
          >{{ getRequestIsUniqueSupplier(item) ? "Si" : "-" }}
        </span>
      </template>
      <template v-slot:item.code="{ item }">
        <span class="mt-2" style="font-size: 11px">
          {{
            item.project
              ? `${getCustomProjectCodeIfIsOv(item.project)}`
              : item.cost_center
              ? item.cost_center.name
              : "-"
          }}

        </span>
      </template>
      <template v-slot:item.shopping_index="{ item }">
        <span class="mt-2" style="font-size: 11px">
          {{ item.shopping_index ? item.shopping_index : "-" }}
        </span>
      </template>
      <template v-slot:item.origin="{ item }">
        <span class="mt-2" style="font-size: 11px">
          {{ item.origin ? item.origin : "-" }}
        </span>
      </template>
      <template v-slot:item.request_type="{ item }">
        <span
          :class="{
            'text-primary font-weight-bold': item.is_maverick,
          }"
          class="mt-2"
          style="font-size: 11px"
        >
          {{
            item.is_maverick
              ? "MAVERICK"
              : ifRequestOfService(item)
              ? item.request_type == REQUEST_MATERIAL
                ? "SOLICITUD DE OC"
                : REQUEST_SERVICE_URGENT
              : item.request_type
          }}
        </span>
      </template>
      <template v-slot:item.created_at="{ item }">
        <span>
          {{ moment(item.created_at).format("DD/MM/YYYY") }}
        </span>
      </template>
      <template v-slot:item.amount="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              {{ "$ " + item.amount.toLocaleString("es", optionsFormatting) }}
            </span>
          </template>
          <label for="">
            Monto Total en Moneda Original:
          </label>
          <br />
          <span>
            {{ getTotalAmountFromApproveRequest(item) }}
          </span>
        </v-tooltip>
      </template>
      <template v-slot:item.sent_to_erp="{ item }">
        <v-chip :color="getColorStatus(item)" class="text-white">
          {{
            item.cancelled
              ? "Anulada"
              : item.rejected
              ? "Rechazada"
              : item.sent_to_erp
              ? "Aprobada"
              : "Pendiente"
          }}</v-chip
        >
      </template>
      <template v-slot:item.sale_order_created="{ item }">
        <v-chip
          v-if="item.sale_approvers && item.sale_approvers.length"
          :color="getColorStatusSaleOc(item)"
          class="text-white"
        >
          {{
            item.cancelled
              ? "Anulada"
              : item.rejected
              ? "Rechazada"
              : item.sale_order_created
              ? "Aprobada"
              : "Pendiente"
          }}</v-chip
        >
        <span v-else>
          -
        </span>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex align-items-center justify-content-center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="openModalListMaterialsRequest(item)"
                icon
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon> mdi-eye </v-icon>
              </v-btn>
            </template>
            <span>Ver Detalles</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="permissionToApprove(item)"
                @click="
                  approveOrRejectedRequestMaterial({
                    item,
                    action: true,
                  })
                "
                icon
                color="success"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon> mdi-check </v-icon>
              </v-btn>
            </template>
            <span>Aprobar solicitud</span>
          </v-tooltip>
          <v-tooltip top>
            <template
              v-slot:activator="{ on, attrs }"
              v-if="
                !item.cancelled &&
                  !item.rejected &&
                  permissionToApproveRequestOc(item) &&
                  item.sale_approvers &&
                  item.sale_approvers.length &&
                  !item.sale_order_created
              "
            >
              <v-btn
                @click="
                  approveOrRejectedRequestSaleOc({
                    item,
                    action: true,
                  })
                "
                icon
                color="success"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon> mdi-check </v-icon>
              </v-btn>
            </template>
            <span>Aprobar OC</span>
          </v-tooltip>
          <v-tooltip
            top
            v-if="
              !item.cancelled &&
                !item.rejected &&
                !item.sent_to_erp &&
                permissionToApproveRequestRestricted(item)
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  approveOrRejectedRequestMaterialRestricted({
                    item,
                    action: true,
                  })
                "
                icon
                color="success"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon> mdi-check </v-icon>
              </v-btn>
            </template>
            <span>Aprobar restricción de solicitud urgente</span>
          </v-tooltip>
          <v-tooltip
            top
            v-if="
              user &&
                normalizeDocumentEmail(item.created_by) === normalizeDocumentEmail(user.email) &&
                !item.approved_index &&
                !item.modified_index &&
                !item.cancelled &&
                !item.rejected &&
                !item.sent_to_erp
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="cancelRequestApprove(item)"
                icon
                color="red darken-2"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon> mdi-delete </v-icon>
              </v-btn>
            </template>
            <span>Anular Solicitud</span>
          </v-tooltip>
          <v-tooltip top v-if="permissionToApprove(item)">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  approveOrRejectedRequestMaterial({
                    item,
                    action: false,
                  })
                "
                icon
                color="red"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon> mdi-cancel </v-icon>
              </v-btn>
            </template>
            <span>Rechazar solicitud</span>
          </v-tooltip>
          <v-tooltip
            top
            v-if="
              !item.cancelled &&
                !item.rejected &&
                permissionToApproveRequestOc(item) &&
                !item.sale_order_created
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  approveOrRejectedRequestSaleOc({
                    item,
                    action: false,
                  })
                "
                icon
                color="red"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon> mdi-cancel </v-icon>
              </v-btn>
            </template>
            <span>Rechazar OC</span>
          </v-tooltip>
          <v-tooltip
            right
            v-if="
              !item.cancelled &&
                !item.rejected &&
                !item.sent_to_erp &&
                permissionToApproveRequestRestricted(item)
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  approveOrRejectedRequestMaterialRestricted({
                    item,
                    action: false,
                  })
                "
                icon
                color="red"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon> mdi-cancel </v-icon>
              </v-btn>
            </template>
            <span>Rechazar restricción de solicitud urgente</span>
          </v-tooltip>
          <v-tooltip top v-if="item.sent_to_erp">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="openModalShowRequestMaterials(item)"
                icon
                :loading="loadingShowRequestMaterial"
                class="mx-1"
                color="primary"
                v-bind="attrs"
                v-on="on"
                x-small
              >
                <v-icon> mdi-truck-outline </v-icon>
              </v-btn>
            </template>
            <span>Ver las solicitudes</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="ifRequestOfService(item)"
                @click="openModalCommentsRequest(item)"
                icon
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-badge
                  :content="
                    item.service_requests[0].comments &&
                    item.service_requests[0].comments.length
                      ? item.service_requests[0].comments.length
                      : '0'
                  "
                  :color="
                    item.service_requests[0].comments &&
                    item.service_requests[0].comments.length
                      ? 'success'
                      : 'red'
                  "
                  overlap
                >
                  <v-icon
                    class="mr-2"
                    color="primary"
                    style="font-size: 1.1rem;"
                  >
                    mdi-comment-outline
                  </v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Ver Comentarios</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <div class="float-right mt-5">
      <v-pagination
        :total-visible="8"
        v-model="filters.page"
        :length="approveRequests ? approveRequests.total_pages : 1"
      ></v-pagination>
    </div>

    <modal-show-request-materials
      :modalAction="dialogShowRequestMaterials"
      :closeModalShowRequestMaterials="closeModalShowRequestMaterials"
      :currentRequestMaterials="currentRequestMaterialsModalShow"
    >
    </modal-show-request-materials>

    <RequestDetails
      @requestUpdated="getApprovedRequestsData(1)"
      ref="requestMaterialItems"
      :currentRequestMaterials="currentRequestMaterials"
      :modalAction="dialogListMaterialsRequest"
      :closeModalListMaterialsRequest="closeModalListMaterialsRequest"
    ></RequestDetails>
    <modal-comments-service
      :modalAction="dialogCommmentsRequest"
      :closeModalComments="closeModalCommentsRequest"
      :currentRequest="currentRequestService"
      @commentAdded="getApprovedRequestsData(filters.page)"
      :addComments="false"
      :moduleQuote="true"
    >
    </modal-comments-service>

    <div id="listMaterialsSelected" style="display: none">
      <table-materials
        ref="approveOrRejectRequest"
        :materials="materialsToApproveOrReject"
      >
        <template v-slot:comment>
          <v-textarea
            outlined
            rows="3"
            class="mt-2 mb-3"
            v-model="form.comment"
            hide-details
          ></v-textarea>
        </template>
      </table-materials>
    </div>
  </section>
</template>

<script>
import { preventCloseIfNotKeyEventEsc, normalizeDocumentEmail } from "@/helpers/common";
import RequestDetails from "./RequestDetails.vue";
import TableMaterials from "./TableMaterials.vue";
import moment from "moment";
import {
  STATUS_REQUESTS_MATERIALS,
  REQUEST_SERVICE,
  REQUEST_SERVICE_URGENT,
  REQUEST_MATERIAL,
  REQUEST_MATERIAL_URGENT,
} from "@/constants/requestMaterial";
import { STATUS_APPROVAL_LIST } from "@/constants/approval";
import { authUsuarioComputed } from "@/state/helpers";
import { mapActions, mapGetters } from "vuex";
import { OPTIONS_AMOUNT_FORMATTING } from "@/constants/common";
import ModalShowRequestMaterials from "@/router/views/requestMaterials/components/ModalShowRequestMaterials.vue";
import REQUEST_SERVICE_CONSTANTS from "@/constants/requestService";
import ModalCommentsService from "@/router/views/requestServices/components/ModalCommentsService.vue";
import { BUSINESS_UNIT_RESIDENTIAL_CODE } from "@/constants/presale";
import { getCustomProjectCodeIfIsOv } from "@/helpers/project";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  components: {
    TableMaterials,
    RequestDetails,
    ModalShowRequestMaterials,
    ModalCommentsService,
  },
  mounted() {
    this.getApprovedRequestsData();
    if (!this.$route.query.sap_project) {
      this.getProjectsData();
      this.getCecosData();
    }
  },
  watch: {
    "filters.page": function(page) {
      this.getApprovedRequestsData(page);
    },
    // "filters.filter": function(page) {

    //   this.getApprovedRequestsData(page);
    // },
    tab: function(tab) {
      this.filters.page = 1;
      this.getApprovedRequestsData(1);
    },
    approveRequests(approveRequests) {
      if (this.currentRequestMaterials) {
        this.changeCurrentRequestMaterials(this.currentRequestMaterials);
      }
    },
  },
  data() {
    return {
      tab: 0,
      moment,
      REQUEST_SERVICE,
      REQUEST_SERVICE_URGENT,
      REQUEST_MATERIAL,
      REQUEST_MATERIAL_URGENT,
      approvedRequestsStatus: STATUS_APPROVAL_LIST,
      loadingApproveRequests: false,
      loadingShowRequestMaterial: false,
      loadingProjects: false,
      loadingCecos: false,
      optionsFormatting: OPTIONS_AMOUNT_FORMATTING,
      currentRequestMaterials: null,
      currentRequestService: null,
      materialsToApproveOrReject: [],
      dialogListMaterialsRequest: false,
      dialogCommmentsRequest: false,
      statusRequests: STATUS_REQUESTS_MATERIALS,

      // ModalShowRequestMaterials
      dialogShowRequestMaterials: false,
      currentRequestMaterialsModalShow: null,

      filters: {
        page: 1,
        filter: "",
        sale_order: null,
        status_filter: STATUS_APPROVAL_LIST[0].id,
        project_code: null,
        cost_center: null,
        sort_by: null,
        sort_order: null,
      },
      debounceApproveRequests: null,
      debounceProjects: null,
      debounceCecos: null,
      debounceTime: 500,
      pageCount: 0,
      keyTable: 999,
      tableHeaders: [
        {
          text: "Proveedor Único",
          align: "center",
          sortable: false,
          value: "unique_supplier",
        },

          {
          text: "Proveedor Único con Contrato",
          align: "center",
          sortable: false,
          value: "unique_supplier_contract",
        },

        {
          text: "Fecha de Creación",
          align: "center",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Tipo",
          align: "center",
          sortable: false,
          value: "request_type",
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "sent_to_erp",
        },
        {
          text: "Estado OC",
          align: "center",
          sortable: false,
          value: "sale_order_created",
        },
        {
          text: "Monto Total",
          align: "center",
          sortable: true,
          value: "amount",
        },
      ],
      breadcrumb: [
        {
          text: "Proyectos",
          disabled: false,
          href: "/",
        },
        {
          text: "Solicitudes de Aprobación",
          disabled: true,
          href: "/request-materials/approvals",
        },
      ],
    };
  },
  methods: {
    normalizeDocumentEmail,
    ...mapActions({
      approveOrRejectRequestApprove:
        "requestMaterial/approveOrRejectRequestApprove",
      approveOrRejectRequestApproveOc:
        "requestMaterial/approveOrRejectRequestApproveOc",
      sendApproveOrRejectRequestApproveRestricted:
        "requestMaterial/approveOrRejectRequestApproveRestricted",
      sendCancelRequestApprove: "requestMaterial/cancelRequestApprove",
      getMaterialsRequestsToApprove:
        "requestMaterial/getMaterialsRequestsToApprove",
      getMaterialsInfoList: "requestMaterialsSap/getMaterialsInfoList",
      updateDataMaterialsCurrentRequestApprove:
        "requestMaterial/updateDataMaterialsCurrentRequestApprove",
      getProjects: "requestMaterialsSap/getProjects",
      getCecos: "requestMaterialsSap/getCecos",
      getProjectInfo: "project/getProjectInfo",
      getRequestMaterials: "requestMaterialsSap/getRequestMaterials",
      getSaleOrders: "project/getSaleOrders",
      clearAvailableSaleOrders: "project/clearSaleOrders",
    }),
    getCustomProjectCodeIfIsOv,
    getTotalAmountFromApproveRequest(item) {
      //Si es solicitud de materiales o los servicios son de mas de una moneda, devolver el monto de la solicitud de aprobación CLP
      if (
        !this.ifRequestOfService(item) ||
        REQUEST_SERVICE_CONSTANTS.verifyIfHaveMoreThanOneCoinInDocuments(
          item.service_requests[0].items
        )
      ) {
        return (
          item.amount.toLocaleString("es", this.optionsFormatting) + " CLP"
        );
      }
      let totalAmountCalculated = REQUEST_SERVICE_CONSTANTS.calculateTotalAmountFromDocuments(
        item.service_requests[0].items
      );
      return `${totalAmountCalculated.total.toLocaleString(
        "es",
        this.optionsFormatting
      )} ${totalAmountCalculated.coin}`;
    },
    rowColor(item) {
      if (item.is_maverick || this.getRequestIsUniqueSupplier(item)) {
        return "bg-maverick";
      }
      return "";
    },
    ifRequestOfService(requestApprove) {
      return requestApprove.service_requests.length ? true : false;
    },
    getRequestIsUniqueSupplier(requestApprove) {
      if (requestApprove.service_requests.length) {
        return REQUEST_SERVICE_CONSTANTS.ifRequestApproveIsUniqueSupplier(
          requestApprove.service_requests[0]
        );
      }
      return false;
    },
    async getApprovedRequestsData(page = 1) {
      let self = this;
      self.filters.page = page;
      clearTimeout(self.debounceApproveRequests);
      self.debounceApproveRequests = setTimeout(async () => {
        self.loadingApproveRequests = true;
        const params = {
          page,
          filter: self.filters.filter ? self.filters.filter : undefined,
          status_filter: self.filters.status_filter
            ? self.filters.status_filter
            : undefined,
          project_code: self.filters.sale_order
            ? self.saleOrdersFromProject.find(
                (item) => item.name == self.filters.sale_order
              ).code
            : self.$route.query.sap_project
            ? self.$route.query.sap_project
            : self.filters.project_code
            ? self.filters.project_code.split(" - ")[0]
            : undefined,
          cost_center: self.filters.cost_center
            ? self.filters.cost_center.split(" - ")[0]
            : undefined,
          sort_by: self.filters.sort_by ? self.filters.sort_by : undefined,
          sort_order: self.filters.sort_order
            ? self.filters.sort_order
            : undefined,
        };
        if (self.tab == 0) {
          params.user = self.user.email;
        } else {
          params.created_by = self.user.email;
        }
        await self.getMaterialsRequestsToApprove(params);
        self.loadingApproveRequests = false;
      }, self.debounceTime);
    },
    async updateSortBy(sortBy) {
      if (sortBy) {
        this.filters.sort_by =
          sortBy == "sale_order_created"
            ? "sale_order_created_at"
            : sortBy == "code"
            ? "project"
            : sortBy;
        this.filters.sort_order = "asc";
        await this.getApprovedRequestsData();
      } else {
        this.filters.sort_by = "created_at";
        this.filters.sort_order = "desc";
        await this.getApprovedRequestsData();
      }
    },
    async updateSortDesc(sortDesc) {
      if (sortDesc) {
        this.filters.sort_order = "desc";
        await this.getApprovedRequestsData();
      }
    },
    async changeProjectFilter() {
      let self = this;
      if (this.currentFilterProjectIsResidential) {
        await this.getSaleOrdersData();
      }
      if (
        self.filters.project_code &&
        self.projects.items.find(
          (item) => item.code == self.filters.project_code.split(" - ")[0]
        ).can_create_ovs &&
        !self.filters.sale_order
      ) {
        return;
      }
      this.getApprovedRequestsData(1);
    },
    async getSaleOrdersData(search = "") {
      if (this.filters.project_code || this.$route.query.sap_project) {
        if (
          (search && search.type) ||
          ((search || typeof search == "string") &&
            this.filters.sale_order !== search)
        ) {
          const res = await this.getSaleOrders({
            parent_project_code: this.$route.query.sap_project
              ? this.$route.query.sap_project
              : this.filters.project_code?.split(" - ")[0],
          });
          this.filters.sale_order = null;
        }
      } else {
        this.filters.sale_order = null;
        this.clearAvailableSaleOrders();
      }
    },
    changeCurrentRequestMaterials(requestMaterials) {
      let requestMaterialsUpdated = this.approveRequests.items.find(
        (item) => item.id == requestMaterials.id
      );
      this.currentRequestMaterials = requestMaterialsUpdated;
    },
    permissionToApprove(requestMaterial) {
      if (this.user && requestMaterial.request_approvers) {
        return (
          (requestMaterial.request_approvers.find((item) => {
            return (
              (normalizeDocumentEmail(item.approver.email) === normalizeDocumentEmail(this.user.email) ||
                item.approver.substituting_for.find(
                  ({ substitute }) =>
                    normalizeDocumentEmail(substitute.email) === normalizeDocumentEmail(this.user.email)
                )) &&
              ((!requestMaterial.approved_index && item.order == 1) ||
                item.order - requestMaterial.approved_index == 1)
            );
          }) !== undefined ||
            (!requestMaterial.request_approvers.length &&
              normalizeDocumentEmail(this.user.email) === normalizeDocumentEmail(requestMaterial.created_by))) &&
          !requestMaterial.sent_to_erp &&
          !requestMaterial.rejected &&
          !requestMaterial.cancelled
        );
      }
      return false;
    },
    permissionToApproveRequestOc(requestMaterial) {
      if (this.user && requestMaterial.sale_approvers) {
        return (
          requestMaterial.sale_approvers.find((item) => {
            return (
              (normalizeDocumentEmail(item.approver.email) === normalizeDocumentEmail(this.user.email) ||
                item.approver.substituting_for.find(
                  ({ substitute }) =>
                    normalizeDocumentEmail(substitute.email) === normalizeDocumentEmail(this.user.email)
                )) &&
              ((!requestMaterial.sale_approval_index && item.order == 1) ||
                item.order - requestMaterial.sale_approval_index == 1)
            );
          }) !== undefined
        );
      }
      return false;
    },
    permissionToApproveRequestRestricted(item) {
      return (
        this.user &&
        item.restricted &&
        item.restriction_approvers.find((approver) => {
          return normalizeDocumentEmail(approver.approver.email) === normalizeDocumentEmail(this.user.email);
        })
      );
    },
    getColorStatus(item) {
      if (item && (item.rejected || item.cancelled)) {
        return "red darken-2";
      }
      switch (item.sent_to_erp) {
        case this.statusRequests.pending:
          return "yellow darken-4";
        case this.statusRequests.accepted:
          return "blue darken-2";
        default:
          break;
      }
    },
    getColorStatusSaleOc(item) {
      if (item && (item.rejected || item.cancelled)) {
        return "red darken-2";
      }
      switch (item.sale_order_created) {
        case this.statusRequests.pending:
          return "yellow darken-4";
        case this.statusRequests.accepted:
          return "blue darken-2";
        default:
          break;
      }
    },
    openModalCommentsRequest(item) {
      this.currentRequestService = {
        ...item.service_requests[0],
        shopping_index: item.shopping_index,
      };
      this.dialogCommmentsRequest = true;
    },
    closeModalCommentsRequest() {
      this.currentRequestService = null;
      this.dialogCommmentsRequest = false;
    },
    async openModalListMaterialsRequest(
      requestMaterial,
      openApprovers = false
    ) {
      let self = this;
      this.currentRequestMaterials = requestMaterial;
      if (requestMaterial.project) {
        await self.getProjectInfo({
          project_code: requestMaterial.project
            ? requestMaterial.project.code
            : requestMaterial.cost_center.code,
        });
      }
      this.dialogListMaterialsRequest = true;
      if (openApprovers) {
        setTimeout(() => {
          self.$refs["requestMaterialItems"].openApproversList();
        }, 1000);
      }
    },
    closeModalListMaterialsRequest($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.currentRequestMaterials = null;
        this.dialogListMaterialsRequest = false;
      }
    },
    async cancelRequestApprove(item) {
      let self = this;
      this.$swal
        .fire({
          icon: "warning",
          title: `¿Estás seguro de anular la ${
            this.ifRequestOfService(item)
              ? "solicitud de OC"
              : "solicitud de materiales"
          } con código de ${item.project ? "Proyecto" : "CECO"}: ${
            item.project ? item.project.code : item.cost_center.name
          }`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: `Anular`,
          confirmButtonColor: "red",
          cancelButtonText: `Cancelar`,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const response = await self.sendCancelRequestApprove({
              request_id: item.id,
              user: self.user.email,
            });
            if (response.status == 200) {
              self.$swal.fire({
                icon: "success",
                title: "Excelente",
                text: `Solicitud anulada con éxito`,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 4000,
                timerProgressBar: true,
              });
              this.getApprovedRequestsData(1);
            }
            if (response.status == 500) {
              self.$swal.fire({
                icon: "error",
                title: "Error",
                text:
                  "Ha ocurrido un error en el servidor, intentalo nuevamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 4000,
                timerProgressBar: true,
              });
            }
          }
        });
    },
    async approveOrRejectedRequestMaterial({ item, action }) {
      let self = this;
      if (!item.service_requests.length) {
        const listMaterials = await this.getMaterialsInfoList({
          material_list: item.materials
            .map((material) => material.code)
            .join(","),
        });
        this.updateDataMaterialsCurrentRequestApprove({
          id: item.id,
          materials: listMaterials.materials,
          is_service: false,
        });
      } else {
        this.updateDataMaterialsCurrentRequestApprove({
          id: item.id,
          materials: item.service_requests[0].items,
          is_service: true,
        });
      }
      self.materialsToApproveOrReject = item.materials;
      let listMaterialsSelectedEl = document.getElementById(
        "listMaterialsSelected"
      );
      await setTimeout(async () => {
        await this.$swal
          .fire({
            icon: "warning",
            title: `¿Estás seguro de ${action ? "aprobar" : "rechazar"} la ${
              this.ifRequestOfService(item)
                ? "solicitud de OC"
                : "solicitud de materiales"
            } con código de ${item.project ? "Proyecto" : "CECO"}: ${
              item.project ? item.project.code : item.cost_center.name
            } con los siguientes ${
              this.ifRequestOfService(item) ? "servicios" : "materiales"
            }?`,
            html: listMaterialsSelectedEl.innerHTML,
            showCancelButton: true,
            showConfirmButton: true,
            customClass: "swal-width-modal",
            confirmButtonText: `${action ? "Aprobar" : "Rechazar"}`,
            confirmButtonColor: action ? "#1076D0" : "red",
            cancelButtonText: `Cancelar`,
            input: "textarea",
            inputPlaceholder: action
              ? "Comentario (Opcional)"
              : "Motivo de Rechazo",
            inputValue: "",
            inputAttributes: {
              class: "mt-5",
            },
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              const value = result.value;
              if (!action && !value) {
                self.$swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "El motivo de rechazo es requerido",
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 4000,
                  timerProgressBar: true,
                });
                return;
              }
              const response = await self.approveOrRejectRequestApprove({
                request_id: item.id,
                user: self.user.email,
                approval: action,
                comment: result.value,
              });
              if (!response?.response || response.response.status == 500) {
                self.$swal.fire({
                  icon: "error",
                  title: "Error",
                  text:
                    "Ha ocurrido un error en el servidor, intentalo nuevamente",
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 4000,
                  timerProgressBar: true,
                });
              }
              if (
                response?.response &&
                (response.response.status == 400 ||
                  response.response.status == 404)
              ) {
                self.$swal.fire({
                  icon: "error",
                  title: "Error",
                  text: response.response.data.detail.message
                    ? response.response.data.detail.message.value
                    : response.response.data.detail,
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 4000,
                  timerProgressBar: true,
                });
              }
              if (response.status == 200) {
                self.$swal.fire({
                  icon: "success",
                  title: "Excelente",
                  text: `Solicitud ${
                    action ? "Aprobada" : "Rechazada"
                  } con éxito`,
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 4000,
                  timerProgressBar: true,
                });
                self.keyTable++;
                this.getApprovedRequestsData(1);
              }
            }
          });
      }, 300);
    },
    async approveOrRejectedRequestSaleOc({ item, action }) {
      let self = this;
      this.updateDataMaterialsCurrentRequestApprove({
        id: item.id,
        materials: item.service_requests[0].items,
        is_service: true,
      });
      self.materialsToApproveOrReject = item.materials;
      let listMaterialsSelectedEl = document.getElementById(
        "listMaterialsSelected"
      );
      await setTimeout(async () => {
        await this.$swal
          .fire({
            icon: "warning",
            title: `¿Estás seguro de ${
              action ? "aprobar" : "rechazar"
            } la Orden de Compra con código de ${
              item.shopping_index
            } con los siguientes servicios?`,
            html: listMaterialsSelectedEl.innerHTML,
            showCancelButton: true,
            showConfirmButton: true,
            customClass: "swal-width-modal",
            confirmButtonText: `${action ? "Aprobar" : "Rechazar"}`,
            confirmButtonColor: action ? "#1076D0" : "red",
            cancelButtonText: `Cancelar`,
            input: "textarea",
            inputPlaceholder: action
              ? "Comentario (Opcional)"
              : "Motivo de Rechazo",
            inputValue: "",
            inputAttributes: {
              class: "mt-5",
            },
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              const value = result.value;
              if (!action && !value) {
                self.$swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "El motivo de rechazo es requerido",
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 4000,
                  timerProgressBar: true,
                });
                return;
              }
              const response = await self.approveOrRejectRequestApproveOc({
                request_id: item.id,
                user: self.user.email,
                approval: action,
                comment: result.value,
              });
              if (!response?.response || response.response.status == 500) {
                self.$swal.fire({
                  icon: "error",
                  title: "Error",
                  text:
                    "Ha ocurrido un error en el servidor, intentalo nuevamente",
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 4000,
                  timerProgressBar: true,
                });
              }
              if (
                response?.response &&
                (response.response.status == 400 ||
                  response.response.status == 404)
              ) {
                self.$swal.fire({
                  icon: "error",
                  title: "Error",
                  text: response.response.data.detail.message
                    ? response.response.data.detail.message.value
                    : response.response.data.detail,
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 4000,
                  timerProgressBar: true,
                });
              }
              if (response.status == 200) {
                self.$swal.fire({
                  icon: "success",
                  title: "Excelente",
                  text: `Orden de Compra ${
                    action ? "Aprobada" : "Rechazada"
                  } con éxito`,
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 4000,
                  timerProgressBar: true,
                });
                self.keyTable++;
                this.getApprovedRequestsData(1);
              }
            }
          });
      }, 300);
    },
    async approveOrRejectedRequestMaterialRestricted({ item, action }) {
      let self = this;
      await setTimeout(async () => {
        await self.$swal
          .fire({
            icon: "warning",
            title: `¿Estás seguro de ${
              action ? "aprobar" : "rechazar"
            } la restricción de la ${
              this.ifRequestOfService(item)
                ? "solicitud de OC"
                : "solicitud de materiales"
            } urgente con código de ${item.project ? "Proyecto" : "CECO"}: ${
              item.project ? item.project.code : item.cost_center.name
            } ?`,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: `${action ? "Aprobar" : "Rechazar"}`,
            confirmButtonColor: action ? "primary" : "red",
            cancelButtonText: `Cancelar`,
            input: "textarea",
            inputPlaceholder: action
              ? "Comentario (Opcional)"
              : "Motivo de Rechazo",
            inputValue: "",
            inputAttributes: {
              class: "mt-5",
            },
            stopKeydownPropagation: false,
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              const value = result.value;
              if (!action && !value) {
                self.$swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "El motivo de rechazo es requerido",
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 4000,
                  timerProgressBar: true,
                });
                return;
              }
              const response = await self.sendApproveOrRejectRequestApproveRestricted(
                {
                  request_id: item.id,
                  user: self.user.email,
                  approval: action,
                  comment: result.value,
                }
              );
              if (response.status == 400 || response.status == 404) {
                self.$swal.fire({
                  icon: "error",
                  title: "Error",
                  text: response.data.detail,
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 4000,
                  timerProgressBar: true,
                });
              }
              if (response.status == 200) {
                self.$swal.fire({
                  icon: "success",
                  title: "Excelente",
                  text: `Restricción de solicitud ${
                    action ? "Aprobada" : "Rechazada"
                  } con éxito`,
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 4000,
                  timerProgressBar: true,
                });
                this.getApprovedRequestsData(1);
              }
              if (response.status == 500) {
                self.$swal.fire({
                  icon: "error",
                  title: "Error",
                  text:
                    "Ha ocurrido un error en el servidor, intentalo nuevamente",
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 4000,
                  timerProgressBar: true,
                });
              }
            }
          });
      }, 300);
    },
    async getProjectsData(search = "") {
      if (
        (search && search.type) ||
        ((search || typeof search == "string") &&
          this.filters.project_code !== search)
      ) {
        this.loadingProjects = true;
        clearTimeout(this.debounceProjects);
        let self = this;
        this.debounceProjects = setTimeout(async function() {
          await self.getProjects({
            filter: search && !search.type ? search : undefined,
            items: 20,
          });
          self.loadingProjects = false;
        }, self.debounceTime);
      }
    },
    async getCecosData(search = "") {
      if (
        (search && search.type) ||
        ((search || typeof search == "string") &&
          this.filters.cost_center !== search)
      ) {
        this.loadingCecos = true;
        clearTimeout(this.debounceCecos);
        let self = this;
        this.debounceCecos = setTimeout(async function() {
          await self.getCecos({
            filter: search && !search.type ? search : undefined,
            items: 20,
          });
          self.loadingCecos = false;
        }, self.debounceTime);
      }
    },
    async openModalShowRequestMaterials(requestApprove) {
      this.loadingShowRequestMaterial = true;
      const response = await this.getRequestMaterials({
        purchase_order: requestApprove.shopping_index,
      });
      if (response.items.length) {
        this.currentRequestMaterialsModalShow = response.items[0];
        this.dialogShowRequestMaterials = true;
      } else {
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: `No se encontraron Solicitudes asociadas a la aprobación de Cesta de Compra: ${requestApprove.shopping_index}`,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
        });
      }
      this.loadingShowRequestMaterial = false;
    },
    closeModalShowRequestMaterials() {
      this.currentRequestMaterialsModalShow = null;
      this.dialogShowRequestMaterials = false;
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      loading: "requestMaterial/loading",
      approveRequests: "requestMaterial/materialsRequestsToApprove",
      projects: "requestMaterialsSap/projects",
      cecos: "requestMaterialsSap/cecos",
      projectInfo: "project/projectInfo",
      saleOrders: "project/saleOrders",
    }),
    wrappedHeaders() {
      if (this.$route.query.sap_project) {
        return [
          {
            text: "Acciones",
            align: "start",
            sortable: false,
            value: "actions",
          },
          {
            text: "Cesta de Compra",
            align: "center",
            value: "shopping_index",
            sortable: true,
          },

          ...this.tableHeaders,
        ];
      }
      return [
        {
          text: "Acciones",
          align: "center",
          sortable: false,
          value: "actions",
        },
        {
          text: "Cesta de Compra",
          align: "center",
          value: "shopping_index",
          sortable: true,
        },
        {
          text: "Proyecto/CECO",
          align: "center",
          value: "code",
          sortable: true,
        },
        ...this.tableHeaders,
      ];
    },
    currentFilterProjectIsResidential() {
      return (
        this.filters.project_code &&
        this.projects.items.find(
          (item) =>
            item.code == this.filters.project_code.split(" - ")[0] &&
            item.business_unit.sap_code == BUSINESS_UNIT_RESIDENTIAL_CODE &&
            item.can_create_ovs
        ) != null
      );
    },
    saleOrdersFromProject() {
      return this.saleOrders.items;
    },
  },
};
</script>

<style>
.bg-maverick {
  background-color: #fff1ea !important;
}
.bg-unique-supplier {
  background-color: rgb(233, 179, 232) !important;
}

.text-unique-supplier {
  color: #e3f2fd !important;
}
.swal-width-modal {
  width: 900px !important;
}
</style>